import { db } from '@/firebase/client';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';

export type CartProductCount = {
  id: string; // product uuid
  count: number;
};

// カートに追加または数量修正
export async function setCartCount(uid: string, count: number) {
  return setDoc(
    doc(db, 'users', uid),
    { cart: Number(count) },
    { merge: true },
  );
}

// カート数量を取る
export async function watchCartProductCount(
  uid: string,
  onChange: (count: number) => void,
) {
  return onSnapshot(doc(db, 'users', uid), (snapshot) => {
    const res = snapshot.data();
    onChange(res?.cart || 0);
  });
}
